import { colors, FelaCSS, spacing } from '@bridebook/ui';

interface IStyles {
  listWrapper: FelaCSS;
  innerListWrapper: FelaCSS;
  label: FelaCSS;
}

const styles: IStyles = {
  listWrapper: {
    paddingTop: spacing[4],
    gap: spacing[3],
  },
  innerListWrapper: {
    paddingLeft: spacing[4],
    gap: spacing[3],
  },
  label: {
    color: colors.space,
  },
};

export default styles;
